<template>
    <md-dialog
        class="mdlp-dialog"
        :md-active.sync="show"
        v-on:md-opened="showMdlpDialog">
        <md-toolbar class="md-primary">
            <h3>Поиск документов МДЛП</h3>
        </md-toolbar>
        <form @submit.stop.prevent="lookForMDLP" class="md-layout md-alignment-center" style="padding-left:20px; padding-rigt: 20px; padding-bottom: 0px">
            <md-field
                :class="{'md-invalid': mdlpLookupValue && this.mdlpInputError.length}"
                class="md-layout-item"
                >
                <label for="mdlpLookupInput"> {{
                    mdlpLookupValue && mdlpInputError ? mdlpInputError : 'Введите номер документа поставщика'
                    }}</label>
                <md-input id="mdlpLookupInput" v-model="mdlpLookupValue"></md-input>
            </md-field>
            <md-button
                class="md-raised md-primary"
                style="width: 100px"
                :disabled="mdlpLookupInProgress"
                @click="lookForMDLP">Найти</md-button>
            
        </form>
        <div class="mdlp-progress">
            <md-progress-bar md-mode="indeterminate" v-show="mdlpLookupInProgress || mdlpContentLookupInProgress || mdlp416LookupInPorgress"></md-progress-bar>
        </div>
        <span>
            <md-button @click="activeMdlpTab = 0" class="mdlp-tab-button" v-bind:class="{'mdlp-active-tab-button': activeMdlpTab == 0}">
                Документы поставщика
            </md-button>
            <md-button @click="activeMdlpTab = 1" class="mdlp-tab-button" v-bind:class="{'mdlp-active-tab-button': activeMdlpTab == 1}">
                Состав документа поставщика
            </md-button>
            <md-button @click="activeMdlpTab = 2" class="mdlp-tab-button" v-bind:class="{'mdlp-active-tab-button': activeMdlpTab == 2}">
                416 документы МДЛП
            </md-button>
        </span>
        <div style="display: contents">
            <md-table
                v-if="activeMdlpTab == 0 && mdlpLookupResult.length != 0"
                v-model="mdlpLookupResult"
                md-fixed-header
                md-card
                md-height="100%">
                <md-table-row slot="md-table-row" slot-scope="{item}">
                    <md-table-cell md-card md-label="Номер док-та" class="md-layout-item md-size-10">{{item.doc}}</md-table-cell>
                    <md-table-cell md-label="Дата" class="md-layout-item md-size-5">{{item.docDate}}</md-table-cell>
                    <md-table-cell md-label="Поставщик" class="md-layout-item md-size-25">{{item.firmaName}}</md-table-cell>
                    <md-table-cell md-label="Код пост." class="md-layout-item md-size-5">{{item.firmaId}}</md-table-cell>
                    <md-table-cell md-label="Код пост. МДЛП" class="md-layout-item md-size-5">{{item.firmaMdlpId}}</md-table-cell>
                    <md-table-cell class="md-layout-item md-size-40">
                            <md-button
                                @click="getMdlpDoc(item, true)"
                                class="md-dense md-primary grid-button"
                                :disabled="mdlpLookupInProgress || mdlp416LookupInPorgress">
                                Первый 416 док.
                            </md-button>
                            <md-button	
                                @click="getMdlpDoc(item, false)"
                                class="md-dense md-primary grid-button"
                                :disabled="mdlpLookupInProgress || mdlp416LookupInPorgress">
                                Все 416 док.
                            </md-button>
                            <md-button
                                @click="showDocData(item)"
                                class="md-dense md-primary grid-button"
                                :disabled="mdlpLookupInProgress || mdlpContentLookupInProgress">
                                Состав док.
                            </md-button>
                    </md-table-cell>
                </md-table-row>
            </md-table>
            <div>
                <md-table
                    v-if="activeMdlpTab == 1 && selectedMdlpDocForContent.length != 0"
                    v-model="selectedMdlpDocForContent"
                    class="top-tab-table"
                    md-card>
                    <md-table-row slot="md-table-row" slot-scope="{item}">
                        <md-table-cell md-card md-label="Номер док-та" class="md-layout-item md-size-5">{{item.doc}}</md-table-cell>
                        <md-table-cell md-label="Дата" class="md-layout-item md-size-5">{{item.docDate}}</md-table-cell>
                        <md-table-cell md-label="Поставщик" class="md-layout-item md-size-80">{{item.firmaName}}</md-table-cell>
                        <md-table-cell md-label="Код пост." class="md-layout-item md-size-5">{{item.firmaId}}</md-table-cell>
                        <md-table-cell md-label="Код пост. МДЛП" class="md-layout-item md-size-5">{{item.firmaMdlpId}}</md-table-cell>
                    </md-table-row>
                </md-table>
            </div>
            <md-table
                v-if="activeMdlpTab == 1 && mdlpDocData.length != 0"
                v-model="mdlpDocData"
                md-fixed-header
                md-card
                md-height="100%">
                <md-table-row
                    slot="md-table-row"
                    slot-scope="{item}"
                    :style="`background-color:${mdlpColor(item)};`">
                    <md-table-cell md-label="Наименование товара" class="md-layout-item md-size-60">{{item.name}}</md-table-cell>
                    <md-table-cell md-label="МДЛП" class="md-layout-item md-size-10">{{item.mdlpMark ? 'Да' : 'Нет'}}</md-table-cell>
                    <md-table-cell md-label="Кол-во" md-numeric class="md-layout-item md-size-10">{{item.kol}}</md-table-cell>
                    <md-table-cell md-label="Кол-во в обороте" md-numeric class="md-layout-item md-size-10">{{item.kolToSale}}</md-table-cell>
                    <md-table-cell md-label="Кол-во проблемных" md-numeric class="md-layout-item md-size-10">{{item.problems}}</md-table-cell>
                </md-table-row>
            </md-table>
            <div>
                <md-table
                    v-if="activeMdlpTab == 2 && selectedMdlpDocFor416.length != 0"
                    class="top-tab-table"
                    v-model="selectedMdlpDocFor416"
                    md-card>
                    <md-table-row slot="md-table-row" slot-scope="{item}">
                        <md-table-cell md-card md-label="Номер док-та" class="md-layout-item md-size-5">{{item.doc}}</md-table-cell>
                        <md-table-cell md-label="Дата" class="md-layout-item md-size-5">{{item.docDate}}</md-table-cell>
                        <md-table-cell md-label="Поставщик" class="md-layout-item md-size-60">{{item.firmaName}}</md-table-cell>
                        <md-table-cell md-label="Код пост." class="md-layout-item md-size-5">{{item.firmaId}}</md-table-cell>
                        <md-table-cell md-label="Код пост. МДЛП" class="md-layout-item md-size-5">{{item.firmaMdlpId}}</md-table-cell>
                        <md-table-cell class="md-layout-item md-size-20">
                            <a
                                v-if="mdlpXmlZip"
                                v-bind:href="mdlpXmlZip ? mdlpXmlZip.link: ''"
                                v-bind:download="mdlpXmlZip ? mdlpXmlZip.name: ''"
                                style="padding: 0px;">
                            Скачать все файлы в ZIP
                            </a>
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </div>
            <md-table
                v-if="activeMdlpTab == 2 && mdlpXmlData.length != 0"
                v-model="mdlpXmlData"
                md-fixed-header
                md-card
                md-height="100%">
                <md-table-row slot="md-table-row" slot-scope="{item}">
                    <md-table-cell md-label="Дата операции">	{{new Date(item.data.operation_date).toLocaleString()}}</md-table-cell>
                    <md-table-cell md-label="Отправитель (код МДЛП)">{{item.data.subject_id}}</md-table-cell>
                    <md-table-cell md-label="Получатель (код МДЛП)">{{item.data.shipper_id}}</md-table-cell>
                    <md-table-cell>
                        <a
                            v-bind:href="item.link"
                            v-bind:download="`${item.data.doc_num}_${item.data.operation_date.toString().replace(':', '-')}.xml`"
                            style="padding: 0px;">
                            Скачать XML файл
                        </a>
                    </md-table-cell>
                </md-table-row>
            </md-table>
            <div v-if="lookupMessage && activeMdlpTab == 0 || docContentMessage && activeMdlpTab == 1 || xmlMessage && activeMdlpTab == 2" class="empty-state">
                <md-icon class="md-size-5x">search</md-icon>
                <h2>
                    {{lookupMessage && activeMdlpTab == 0 ? lookupMessage : docContentMessage && activeMdlpTab == 1 ? docContentMessage : xmlMessage && activeMdlpTab == 2 ? xmlMessage : ''}}
                </h2>
            </div>
        </div>
        <md-dialog-actions style="padding-left: 8px; margin-top: auto; justify-content: flex-start">
            <div v-if="activeMdlpTab == 0 && mdlpLookupResult.length >= 50">
                Найдено 50 первых документов по дате
            </div>
            <md-button
                class="md-dense md-raised md-accent"
                style="margin-left: auto"
                @click="show = false">
                Закрыть
            </md-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
export default {
    name: "MdlpLookup",
    props: {
        isVisible: Boolean
    },
    data: () => ({
        lookupMessage: '',
        xmlMessage: '',
        docContentMessage: '',
        mdlpIdApt: -1,
        mdlpLookupValue: '',
        mdlpLookupResult: [],
        mdlpLookupInProgress: false,
        mdlpContentLookupInProgress: false,
        mdlp416LookupInPorgress : false,
        mdlpDocData:[],
        mdlpXmlData: [],
        mdlpXmlZip: null,
        selectedMdlpDocFor416: [],
        selectedMdlpDocForContent: [],
        mdplDocDataIsMdlpMarked: false,
        activeMdlpTab: '',
        mdlpInputError: ''
    }),
    methods: {
        mdlpColor(item) {
				const mdlpNoColor = "white";
				const mdlpOkColor = "#D7FFD7";
				const mdlpProblemsColor = "#FFD7D7";
				if (!item.mdlpMark) {
					return mdlpNoColor;
				}
				if (item.problems) {
					return mdlpProblemsColor;
				}
				return mdlpOkColor;
			},
        mdlpTabChanged(id) {
            //this.activeMdlpTab = id;
        },
        getMdlpDoc(item, single) {
            this.selectedMdlpDocFor416 = [item];
            this.activeMdlpTab = 2;
            this.mdlpXmlData = [];
            this.mdlpXmlZip = null;
            this.mdlp416LookupInPorgress = true;
            this.xmlMessage = 'Идет поиск 416 документов МДЛП...';
            this.$http.get('data/FindMdplDoc', {
                params: {
                    idapt: this.mdlpIdApt,
                    docnum: item.doc,
                    docdate: item.docDatePrih,
                    single: single
                }
            }).then(res => {
                var xmlList = res.body.xmlList;
                if (xmlList.length == 0) {
                    this.xmlMessage = single ? '416 документ МДЛП не найден' : '416 документы МДЛП не найден';
                }
                else {
                    this.xmlMessage = '';
                }
                for (var i = 0, cnt = xmlList.length; i < cnt; i++) {
                    var blob = new Blob([xmlList[i].xml], {type: 'application/xml'});
                    var url = URL.createObjectURL(blob);
                    var ro = xmlList[i].obj.documents.receive_order;
                    this.mdlpXmlData[i] = {
                        data: ro,
                        link: url
                    }
                }
                if (res.body.zip) {
                    const byteCharacters = atob(res.body.zip);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    var blob = new Blob([byteArray], {type: 'application/zip'});
                    this.mdlpXmlZip = {
                        link: URL.createObjectURL(blob),
                        name: item.doc + ".zip"
                    }
                }
                else {
                    this.mdlpXmlZip = null;
                }
                this.mdlp416LookupInPorgress = false;
            }, res => {
                this.xmlMessage = 'Ошибка на сервере'
                this.mdlp416LookupInPorgress = false;
            });
        },
        showMdlpDialog() {
            this.lookupMessage = 'Введите номер документа поставщика и нажмите "НАЙТИ"';
            this.xmlMessage = 'Выберите документ поставщика';
            this.docContentMessage = 'Выберите документ поставщика';
            this.mdlpLookupResult = [];
            this.mdlpDocData = [];
            this.mdlpXmlData = [];
            this.mdlpXmlZip = null;
            this.selectedMdlpDocFor416 = [];
            this.selectedMdlpDocForContent = [];
            this.showDialogForMdlpLookup = true;
        },
        containsMdlpMark(item) {
            for (var i = 0, cnt = item.length; i < cnt; i++) {
                if (item[i].mdlpMark) {
                    return true;
                }
            }
            return false;
        },
        showDocData(item) {
            if (!item) {
                return;
            }
            this.selectedMdlpDocForContent = [item];
            this.activeMdlpTab = 1;
            this.mdlpContentLookupInProgress = true;
            this.mdlpDocData = [];
            this.$http.get('data/GetMdplDocData', {
                params: {
                    idkd: item.idKd,
                    idapt: this.mdlpIdApt
                }
            }).then(res => {
                this.mdlpContentLookupInProgress = false;
                this.mdlpDocData = res.body;
                this.docContentMessage = this.mdlpDocData.length == 0 ? 'Состав не найден' : '';
                this.mdplDocDataIsMdlpMarked = this.containsMdlpMark(this.mdlpDocData);
            }, res => {
                this.docContentMessage = 'Ошибка на сервере'
                this.mdlpContentLookupInProgress = false;
            });
        },
        lookForMDLP() {
            var combo = this.mdlpLookupValue.split('@');
            var value = combo[0];
            var idapt = parseInt(combo[1]);
            if (value.length < 3) {
                this.mdlpInputError = 'Не менее трёх символов';
                return;
            }
            this.mdlpInputError = '';
            this.mdlpLookupResult = [];
            this.activeMdlpTab = 0;
            
            this.mdlpIdApt = idapt ? idapt : this.CURRENTAPTEKA.idapt;
            this.mdlpLookupInProgress = true;
            this.lookupMessage = 'Идет поиск документов поставщика...';
            this.$http.get('data/LookForMdlp', {
                    params: {
                        idapt: this.mdlpIdApt,
                        value: value
                    }
                }).
            then(ans => {
                this.mdlpLookupInProgress = false;
                var result = ans.body.length != 0;
                this.lookupMessage = result ? '' : 'Документы поставщика не найдены';
                this.mdlpLookupResult = result ? ans.body : [];
            }, ans => {
                this.mdlpLookupInProgress = false;
                this.lookupMessage = 'Ошибка на сервере';
                }
            );
        }
    },
    computed: {
        show: {
            get() {
                return this.isVisible;
            },
            set(val) {
                if (!val) {
                    this.$emit('mdlp-visible');
                }
            }
        }
    }
}
</script>

<style lang="scss">
    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: auto;
        margin-bottom: auto;
    }
	.top-tab-table {
		margin-bottom: 5px;
	}
	.mdlp-dialog {
		max-width: 100%;
	}
    .md-dialog-container {
		width: 95%;
		height: 95%;
		max-width: 95%;
		max-height: 95%;
	}
	.mdlp-progress {
		min-height: 5px;
		height: 5px;
		padding: 0px;
		margin-top: -16px;
	}
	.mdlp-tab-button {
		border-radius: 0px;
		border-bottom: 2px solid #ffffff;
	}
	.mdlp-active-tab-button {
		border-bottom: 2px solid #448AFF;
	}
	.md-table-fixed-header-container {
		overflow-x: hidden !important;
	}
</style>


// WEBPACK FOOTER //
// Components/supportNew/mdlpLookup.vue